import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as Actions from "actions/seller/seller.store";
import * as AdminProductActions from "actions/admin/admin.products";

import {Box, Container, Button, CircularProgress} from "@mui/material";
import {useEffect, useState, useRef} from "react";

import VideoUpload from "components/VideoUpload";
import VideoPlayer from "components/VideoPlayer";


const AdminProductVideoEditor = (props) => {

  const { serviceError, reqStatus, isLoading, selectedProduct,
      adminUpdateProductVideoClicked, prod_id, video,
      cancelEdit, adminAddCommonProductImage } = props;

  const [isCapturing, setIsCapturing] = useState(false);
  const videoPlayerRef = useRef(null);

    useEffect(() => {
    if (serviceError && reqStatus) {
      const feedback = {
        title: "Something went wrong!",
        description: serviceError.statusText,
      };
      sendNotification("error", feedback);
    }
  }, [serviceError, reqStatus]);

  const sendNotification = (type, { title, description = "" }) => {
    console.log({
      message: title,
      description,
    });
  };

    const addVideoCallback = (file) => {

        const formData = new FormData();
        formData.append('inputFile', file);
//        const newFile = dataURIToBlob("data:video/mp4;base64,"+file);
//        formData.append("video", newFile);
        adminUpdateProductVideoClicked(prod_id, formData);
    }

    const captureFrameAsPrimaryImage = async () => {
        if (!video || !video[0] || !video[0].cdn || !video[0].cdn.secure_url) {
            sendNotification("error", {
                title: "No video available",
                description: "Please upload a video first"
            });
            return;
        }

        setIsCapturing(true);
        
        try {
            // Get the video element from the Cloudinary player
            const videoElement = document.querySelector('#demo-player video');
            
            if (!videoElement) {
                throw new Error("Video player not found");
            }

            // Ensure crossOrigin is set for CORS
            if (!videoElement.crossOrigin) {
                videoElement.crossOrigin = 'anonymous';
            }

            // Wait a bit if video is not ready
            if (videoElement.videoWidth === 0 || videoElement.videoHeight === 0) {
                throw new Error("Video not loaded yet. Please wait for the video to load.");
            }

            // Create a canvas and capture the current frame
            const canvas = document.createElement('canvas');
            canvas.width = videoElement.videoWidth;
            canvas.height = videoElement.videoHeight;
            
            const ctx = canvas.getContext('2d');
            ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
            
            // Convert canvas to blob
            const blob = await new Promise((resolve, reject) => {
                canvas.toBlob((blob) => {
                    if (blob) {
                        resolve(blob);
                    } else {
                        reject(new Error("Failed to create blob from canvas"));
                    }
                }, 'image/jpeg', 0.95);
            });
            
            if (!blob) {
                throw new Error("Failed to capture frame");
            }
            
            // Create FormData and append the captured image
            const formData = new FormData();
            formData.append('inputFile', blob, `frame-${Date.now()}.jpg`);
            formData.append('primary', 'true');
            
            // Upload the image as primary
            adminAddCommonProductImage(prod_id, formData);
            
            sendNotification("success", {
                title: "Frame captured!",
                description: "The captured frame has been uploaded as the primary product image"
            });
            
        } catch (error) {
            console.error("Error capturing frame:", error);
            sendNotification("error", {
                title: "Failed to capture frame",
                description: error.message || "Please ensure the video has loaded completely and try again."
            });
        } finally {
            setIsCapturing(false);
        }
    }


    return (
        <Container>
            <Box >
                <VideoUpload isRemoveAllowed={false}
                             images={video}
                             addVideoCallback={addVideoCallback}
                             cancelEdit={cancelEdit}
                             idx="2"
                />

                <VideoPlayer
                    ref={videoPlayerRef}
                    id="demo-player"
                    publicId={video && video[0] && video[0].cdn.secure_url}
                    width="480"
                    height="720"
                />

                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', gap: 2 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={captureFrameAsPrimaryImage}
                        disabled={isCapturing || !video || !video[0]}
                        startIcon={isCapturing && <CircularProgress size={20} />}
                    >
                        {isCapturing ? 'Capturing...' : 'Capture Frame as Primary Image'}
                    </Button>
                </Box>

            </Box>
        </Container>
    );
};

export default connect(
    null,
    (dispatch) => bindActionCreators({
        ...Actions,
        adminAddCommonProductImage: AdminProductActions.adminAddCommonProductImage
    }, dispatch)
)(AdminProductVideoEditor);
